import { gql } from "lib/apolloClient";

import { staffFragment } from "modules/CommonFragments";

export const folderFragments = {
  folderItem: gql`
    fragment folderItem on Folder {
      id
      name
      color
      totalPostCount
    }
  `,
  folderItemWithFilters: gql`
    fragment folderItemWithFilters on Folder {
      id
      name
      color
      totalPostCount(filters: $filters)
    }
  `,
  folderDetails: gql`
    fragment folderDetails on Folder {
      id
      name
      color
      createdBy {
        ...staffItem
      }
      totalPostCount
    }
    ${staffFragment.basicStaffDetails}
  `,
};
